module.exports = __webpack_public_path__ + "media/images/main/k9-44bb5918191eb895e17c376b8b9c13cc.jpg";